import { render, staticRenderFns } from "./sign_settlementTaskBack.vue?vue&type=template&id=3b6cec18&scoped=true"
import script from "./sign_settlementTaskBack.vue?vue&type=script&lang=js"
export * from "./sign_settlementTaskBack.vue?vue&type=script&lang=js"
import style0 from "./sign_settlementTaskBack.vue?vue&type=style&index=0&id=3b6cec18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6cec18",
  null
  
)

export default component.exports